const DynamicFieldTypes = Object.freeze({
  TEXT: 'text',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATE: 'date',
});

export { DynamicFieldTypes };